import { BACKEND_ORIGIN } from './apiBase';

export const resolveImageUrl = (imageUrl) => {
  if (!imageUrl) {
    return '';
  }

  const raw = String(imageUrl).trim().replace(/\\/g, '/');
  if (!raw) {
    return '';
  }

  const cleanedRaw = raw
    .replace(/^\.\/+/, '')
    .replace(/^public\/+/i, '')
    .replace(/^\/+/, '');

  const forceHttpsIfNeeded = (url) => {
    if (
      typeof window !== 'undefined' &&
      window.location.protocol === 'https:' &&
      url.startsWith('http://')
    ) {
      return `https://${url.slice('http://'.length)}`;
    }
    return url;
  };

  // Absolute URL, data URI, or blob URL should pass through untouched.
  if (/^(https?:)?\/\//i.test(cleanedRaw) || cleanedRaw.startsWith('data:') || cleanedRaw.startsWith('blob:')) {
    return forceHttpsIfNeeded(cleanedRaw);
  }

  const normalizedPath = `/${cleanedRaw}`;

  // Uploaded assets are backend-managed and must resolve against backend origin.
  if (normalizedPath.startsWith('/uploads/')) {
    const resolved = BACKEND_ORIGIN ? `${BACKEND_ORIGIN}${normalizedPath}` : normalizedPath;
    return forceHttpsIfNeeded(resolved);
  }

  if (normalizedPath.startsWith('/api/uploads/')) {
    const uploadsPath = normalizedPath.replace(/^\/api/, '');
    const resolved = BACKEND_ORIGIN ? `${BACKEND_ORIGIN}${uploadsPath}` : uploadsPath;
    return forceHttpsIfNeeded(resolved);
  }

  if (normalizedPath.startsWith('/images/')) {
    return normalizedPath;
  }

  return normalizedPath;
};
